module.exports = __webpack_public_path__ + "static/media/3.17.f81c8a11.png";